export default __webpack_public_path__ + "static/media/curved_arrow_right.3c1d6a62.svg";